import { Component, type ErrorInfo } from 'react';

import { type ErrorBoundaryProps, type ErrorBoundaryState } from './types';

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps | Readonly<ErrorBoundaryProps>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // TODO: TRACE ERROR
    if (import.meta.env.VITE_LOG_ERRORS === 'true' || import.meta.env.DEV) {
      if (this.props.onLogError !== undefined) {
        this.props.onLogError(error, info);
      } else {
        console.error(error, info.componentStack);
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
